<script>
    import FieldError from '../../shared/FieldError.svelte'
    
    export let activity
    export let errors
</script>


<div class="field" class:error={errors["basis.variant.text"]}>
    <label for="text">Texto</label>
    <textarea name="text" rows="4" bind:value={activity.basis.variant.text}></textarea>
    <FieldError style="label" property={errors["basis.variant.text"]}/>
</div>
<div class="field">
    <div class="ui toggle checkbox">
        <input name="fields" type="checkbox" bind:checked={activity.basis.variant.fields}>
        <label for="fields" style="font-size: 1em">incluir campos</label>
    </div>
</div>
<div class="field">
    <div class="ui toggle checkbox">
        <input name="operators" type="checkbox" bind:checked={activity.basis.variant.operators}>
        <label for="operators" style="font-size: 1em">incluir operadores</label>
    </div>
</div>